import { useLoyalty } from "@/hooks/useLoyalty";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Award, TrendingUp } from "lucide-react";

export default function Rewards() {
  const { points, transactions, tier, bookingsCount, loading } = useLoyalty();

  if (loading) return <div className="p-8">Loading...</div>;

  const tierColor = tier === "Gold" ? "bg-yellow-500" : tier === "Silver" ? "bg-gray-400" : "bg-amber-700";

  return (
    <div className="container mx-auto p-6 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6 flex items-center gap-2"><Award className="h-7 w-7" />Your Rewards</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">Points</CardTitle></CardHeader>
          <CardContent><div className="text-3xl font-bold">{points}</div></CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">Tier</CardTitle></CardHeader>
          <CardContent><Badge className={`${tierColor} text-white text-base`}>{tier}</Badge></CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">Completed Bookings</CardTitle></CardHeader>
          <CardContent><div className="text-3xl font-bold">{bookingsCount}</div></CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader><CardTitle className="flex items-center gap-2"><TrendingUp className="h-5 w-5" />Activity</CardTitle></CardHeader>
        <CardContent>
          {transactions.length === 0 ? (
            <p className="text-muted-foreground text-sm">No transactions yet. Complete a booking to earn points!</p>
          ) : (
            <div className="space-y-2">
              {transactions.map((t) => (
                <div key={t.id} className="flex justify-between items-center p-3 border rounded">
                  <div>
                    <div className="text-sm font-medium">{t.reason}</div>
                    <div className="text-xs text-muted-foreground">{new Date(t.created_at).toLocaleDateString()}</div>
                  </div>
                  <span className={`font-bold ${t.points_delta >= 0 ? "text-green-600" : "text-red-600"}`}>
                    {t.points_delta >= 0 ? "+" : ""}{t.points_delta}
                  </span>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
